import { render, staticRenderFns } from "./VisionList.vue?vue&type=template&id=b4557722&"
import script from "./VisionList.vue?vue&type=script&lang=js&"
export * from "./VisionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports